/**
 * Generated by orval 🍺
 * Do not edit manually.
 * [DEV] Backend
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  BulkDeleteTaxonomyAggregatesReq,
  BulkDeleteTaxonomyAggregatesResp,
  GetProjectConfigurationResp,
  HTTPValidationError,
  ListTagsParams,
  ListTagsResp,
  ListTaxonomyAliases200,
  ListTaxonomyParams,
  ListTaxonomyResp,
  TaxonomyAlias,
  TaxonomyApplyEstimateReq,
  TaxonomyApplyEstimateResp,
  TaxonomyRoleResp,
  UpsertTaxonomyAggregateReq,
} from '../model';

import { customFetch } from '../../fetcher';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getGetTaxonomyRoleUrl = () => {
  return `/api/v1/taxonomy/role`;
};

/**
 * @summary Get Taxonomy Role
 */
export const getTaxonomyRole = async (options?: Parameters<typeof customFetch>[1]): Promise<TaxonomyRoleResp> => {
  return customFetch<TaxonomyRoleResp>(getGetTaxonomyRoleUrl(), {
    ...options,
    method: 'GET',
  });
};

export const getGetTaxonomyRoleQueryKey = () => {
  return [`/api/v1/taxonomy/role`] as const;
};

export const getGetTaxonomyRoleQueryOptions = <
  TData = Awaited<ReturnType<typeof getTaxonomyRole>>,
  TError = HTTPValidationError,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getTaxonomyRole>>, TError, TData>;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTaxonomyRoleQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTaxonomyRole>>> = ({ signal }) =>
    getTaxonomyRole({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTaxonomyRole>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetTaxonomyRoleQueryResult = NonNullable<Awaited<ReturnType<typeof getTaxonomyRole>>>;
export type GetTaxonomyRoleQueryError = HTTPValidationError;

/**
 * @summary Get Taxonomy Role
 */

export function useGetTaxonomyRole<
  TData = Awaited<ReturnType<typeof getTaxonomyRole>>,
  TError = HTTPValidationError,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getTaxonomyRole>>, TError, TData>;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetTaxonomyRoleQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getListTaxonomyUrl = (projectId: string, params?: ListTaxonomyParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/v1/taxonomy/${projectId}?${stringifiedParams}`
    : `/api/v1/taxonomy/${projectId}`;
};

/**
 * @summary List Taxonomy
 */
export const listTaxonomy = async (
  projectId: string,
  params?: ListTaxonomyParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<ListTaxonomyResp> => {
  return customFetch<ListTaxonomyResp>(getListTaxonomyUrl(projectId, params), {
    ...options,
    method: 'GET',
  });
};

export const getListTaxonomyQueryKey = (projectId: string, params?: ListTaxonomyParams) => {
  return [`/api/v1/taxonomy/${projectId}`, ...(params ? [params] : [])] as const;
};

export const getListTaxonomyQueryOptions = <
  TData = Awaited<ReturnType<typeof listTaxonomy>>,
  TError = HTTPValidationError,
>(
  projectId: string,
  params?: ListTaxonomyParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof listTaxonomy>>, TError, TData>;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListTaxonomyQueryKey(projectId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listTaxonomy>>> = ({ signal }) =>
    listTaxonomy(projectId, params, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: projectId !== null && projectId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof listTaxonomy>>, TError, TData> & { queryKey: QueryKey };
};

export type ListTaxonomyQueryResult = NonNullable<Awaited<ReturnType<typeof listTaxonomy>>>;
export type ListTaxonomyQueryError = HTTPValidationError;

/**
 * @summary List Taxonomy
 */

export function useListTaxonomy<TData = Awaited<ReturnType<typeof listTaxonomy>>, TError = HTTPValidationError>(
  projectId: string,
  params?: ListTaxonomyParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof listTaxonomy>>, TError, TData>;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListTaxonomyQueryOptions(projectId, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getListTagsUrl = (projectId: string, params?: ListTagsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/v1/taxonomy/${projectId}/tags?${stringifiedParams}`
    : `/api/v1/taxonomy/${projectId}/tags`;
};

/**
 * @summary List Tags
 */
export const listTags = async (
  projectId: string,
  params?: ListTagsParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<ListTagsResp> => {
  return customFetch<ListTagsResp>(getListTagsUrl(projectId, params), {
    ...options,
    method: 'GET',
  });
};

export const getListTagsQueryKey = (projectId: string, params?: ListTagsParams) => {
  return [`/api/v1/taxonomy/${projectId}/tags`, ...(params ? [params] : [])] as const;
};

export const getListTagsQueryOptions = <TData = Awaited<ReturnType<typeof listTags>>, TError = HTTPValidationError>(
  projectId: string,
  params?: ListTagsParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof listTags>>, TError, TData>;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListTagsQueryKey(projectId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listTags>>> = ({ signal }) =>
    listTags(projectId, params, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: projectId !== null && projectId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof listTags>>, TError, TData> & { queryKey: QueryKey };
};

export type ListTagsQueryResult = NonNullable<Awaited<ReturnType<typeof listTags>>>;
export type ListTagsQueryError = HTTPValidationError;

/**
 * @summary List Tags
 */

export function useListTags<TData = Awaited<ReturnType<typeof listTags>>, TError = HTTPValidationError>(
  projectId: string,
  params?: ListTagsParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof listTags>>, TError, TData>;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListTagsQueryOptions(projectId, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getEstimateTaxonomyApplyUrl = (projectId: string) => {
  return `/api/v1/taxonomy/${projectId}/estimate`;
};

/**
 * @summary Estimate Taxonomy Apply
 */
export const estimateTaxonomyApply = async (
  projectId: string,
  taxonomyApplyEstimateReq: TaxonomyApplyEstimateReq,
  options?: Parameters<typeof customFetch>[1],
): Promise<TaxonomyApplyEstimateResp> => {
  const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<TaxonomyApplyEstimateResp>(getEstimateTaxonomyApplyUrl(projectId), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(taxonomyApplyEstimateReq),
  });
};

export const getEstimateTaxonomyApplyMutationOptions = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof estimateTaxonomyApply>>,
    TError,
    EstimateTaxonomyApplyMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof estimateTaxonomyApply>>,
  TError,
  EstimateTaxonomyApplyMutationVariables,
  TContext
> => {
  const mutationKey = ['estimateTaxonomyApply'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof estimateTaxonomyApply>>,
    EstimateTaxonomyApplyMutationVariables
  > = (props) => {
    const { projectId, data } = props ?? {};

    return estimateTaxonomyApply(projectId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type EstimateTaxonomyApplyMutationResult = NonNullable<Awaited<ReturnType<typeof estimateTaxonomyApply>>>;
export type EstimateTaxonomyApplyMutationBody = TaxonomyApplyEstimateReq;
export type EstimateTaxonomyApplyMutationError = HTTPValidationError;
export type EstimateTaxonomyApplyMutationVariables = { projectId: string; data: TaxonomyApplyEstimateReq };

/**
 * @summary Estimate Taxonomy Apply
 */
export const useEstimateTaxonomyApply = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof estimateTaxonomyApply>>,
    TError,
    EstimateTaxonomyApplyMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof estimateTaxonomyApply>>,
  TError,
  EstimateTaxonomyApplyMutationVariables,
  TContext
> => {
  return useMutation(getEstimateTaxonomyApplyMutationOptions(options));
};
export const getUpsertTaxonomyAggregateUrl = (projectId: string) => {
  return `/api/v1/taxonomy/${projectId}/aggregates`;
};

/**
 * @summary Upsert Taxonomy Aggregate
 */
export const upsertTaxonomyAggregate = async (
  projectId: string,
  upsertTaxonomyAggregateReq: UpsertTaxonomyAggregateReq,
  options?: Parameters<typeof customFetch>[1],
): Promise<GetProjectConfigurationResp> => {
  const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<GetProjectConfigurationResp>(getUpsertTaxonomyAggregateUrl(projectId), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(upsertTaxonomyAggregateReq),
  });
};

export const getUpsertTaxonomyAggregateMutationOptions = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof upsertTaxonomyAggregate>>,
    TError,
    UpsertTaxonomyAggregateMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof upsertTaxonomyAggregate>>,
  TError,
  UpsertTaxonomyAggregateMutationVariables,
  TContext
> => {
  const mutationKey = ['upsertTaxonomyAggregate'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof upsertTaxonomyAggregate>>,
    UpsertTaxonomyAggregateMutationVariables
  > = (props) => {
    const { projectId, data } = props ?? {};

    return upsertTaxonomyAggregate(projectId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpsertTaxonomyAggregateMutationResult = NonNullable<Awaited<ReturnType<typeof upsertTaxonomyAggregate>>>;
export type UpsertTaxonomyAggregateMutationBody = UpsertTaxonomyAggregateReq;
export type UpsertTaxonomyAggregateMutationError = HTTPValidationError;
export type UpsertTaxonomyAggregateMutationVariables = { projectId: string; data: UpsertTaxonomyAggregateReq };

/**
 * @summary Upsert Taxonomy Aggregate
 */
export const useUpsertTaxonomyAggregate = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof upsertTaxonomyAggregate>>,
    TError,
    UpsertTaxonomyAggregateMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof upsertTaxonomyAggregate>>,
  TError,
  UpsertTaxonomyAggregateMutationVariables,
  TContext
> => {
  return useMutation(getUpsertTaxonomyAggregateMutationOptions(options));
};
export const getDeleteTaxonomyAggregateUrl = (projectId: string, categoryName: string) => {
  return `/api/v1/taxonomy/${projectId}/aggregates/${categoryName}`;
};

/**
 * @summary Delete Taxonomy Aggregate
 */
export const deleteTaxonomyAggregate = async (
  projectId: string,
  categoryName: string,
  options?: Parameters<typeof customFetch>[1],
): Promise<string> => {
  return customFetch<string>(getDeleteTaxonomyAggregateUrl(projectId, categoryName), {
    ...options,
    method: 'DELETE',
  });
};

export const getDeleteTaxonomyAggregateMutationOptions = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteTaxonomyAggregate>>,
    TError,
    DeleteTaxonomyAggregateMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteTaxonomyAggregate>>,
  TError,
  DeleteTaxonomyAggregateMutationVariables,
  TContext
> => {
  const mutationKey = ['deleteTaxonomyAggregate'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteTaxonomyAggregate>>,
    DeleteTaxonomyAggregateMutationVariables
  > = (props) => {
    const { projectId, categoryName } = props ?? {};

    return deleteTaxonomyAggregate(projectId, categoryName, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteTaxonomyAggregateMutationResult = NonNullable<Awaited<ReturnType<typeof deleteTaxonomyAggregate>>>;

export type DeleteTaxonomyAggregateMutationError = HTTPValidationError;
export type DeleteTaxonomyAggregateMutationVariables = { projectId: string; categoryName: string };

/**
 * @summary Delete Taxonomy Aggregate
 */
export const useDeleteTaxonomyAggregate = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteTaxonomyAggregate>>,
    TError,
    DeleteTaxonomyAggregateMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteTaxonomyAggregate>>,
  TError,
  DeleteTaxonomyAggregateMutationVariables,
  TContext
> => {
  return useMutation(getDeleteTaxonomyAggregateMutationOptions(options));
};
export const getBulkDeleteTaxonomyAggregatesUrl = (projectId: string) => {
  return `/api/v1/taxonomy/${projectId}/aggregates/bulk-delete`;
};

/**
 * @summary Bulk Delete Taxonomy Aggregates
 */
export const bulkDeleteTaxonomyAggregates = async (
  projectId: string,
  bulkDeleteTaxonomyAggregatesReq: BulkDeleteTaxonomyAggregatesReq,
  options?: Parameters<typeof customFetch>[1],
): Promise<BulkDeleteTaxonomyAggregatesResp> => {
  const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<BulkDeleteTaxonomyAggregatesResp>(getBulkDeleteTaxonomyAggregatesUrl(projectId), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(bulkDeleteTaxonomyAggregatesReq),
  });
};

export const getBulkDeleteTaxonomyAggregatesMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof bulkDeleteTaxonomyAggregates>>,
    TError,
    BulkDeleteTaxonomyAggregatesMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof bulkDeleteTaxonomyAggregates>>,
  TError,
  BulkDeleteTaxonomyAggregatesMutationVariables,
  TContext
> => {
  const mutationKey = ['bulkDeleteTaxonomyAggregates'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof bulkDeleteTaxonomyAggregates>>,
    BulkDeleteTaxonomyAggregatesMutationVariables
  > = (props) => {
    const { projectId, data } = props ?? {};

    return bulkDeleteTaxonomyAggregates(projectId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type BulkDeleteTaxonomyAggregatesMutationResult = NonNullable<
  Awaited<ReturnType<typeof bulkDeleteTaxonomyAggregates>>
>;
export type BulkDeleteTaxonomyAggregatesMutationBody = BulkDeleteTaxonomyAggregatesReq;
export type BulkDeleteTaxonomyAggregatesMutationError = HTTPValidationError;
export type BulkDeleteTaxonomyAggregatesMutationVariables = {
  projectId: string;
  data: BulkDeleteTaxonomyAggregatesReq;
};

/**
 * @summary Bulk Delete Taxonomy Aggregates
 */
export const useBulkDeleteTaxonomyAggregates = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof bulkDeleteTaxonomyAggregates>>,
    TError,
    BulkDeleteTaxonomyAggregatesMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof bulkDeleteTaxonomyAggregates>>,
  TError,
  BulkDeleteTaxonomyAggregatesMutationVariables,
  TContext
> => {
  return useMutation(getBulkDeleteTaxonomyAggregatesMutationOptions(options));
};
export const getUpsertTaxonomyTagUrl = (projectId: string) => {
  return `/api/v1/taxonomy/${projectId}/alias`;
};

/**
 * @summary Upsert Alias
 */
export const upsertTaxonomyTag = async (
  projectId: string,
  taxonomyAlias: TaxonomyAlias,
  options?: Parameters<typeof customFetch>[1],
): Promise<TaxonomyAlias> => {
  const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<TaxonomyAlias>(getUpsertTaxonomyTagUrl(projectId), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(taxonomyAlias),
  });
};

export const getUpsertTaxonomyTagMutationOptions = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof upsertTaxonomyTag>>,
    TError,
    UpsertTaxonomyTagMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof upsertTaxonomyTag>>,
  TError,
  UpsertTaxonomyTagMutationVariables,
  TContext
> => {
  const mutationKey = ['upsertTaxonomyTag'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof upsertTaxonomyTag>>,
    UpsertTaxonomyTagMutationVariables
  > = (props) => {
    const { projectId, data } = props ?? {};

    return upsertTaxonomyTag(projectId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpsertTaxonomyTagMutationResult = NonNullable<Awaited<ReturnType<typeof upsertTaxonomyTag>>>;
export type UpsertTaxonomyTagMutationBody = TaxonomyAlias;
export type UpsertTaxonomyTagMutationError = HTTPValidationError;
export type UpsertTaxonomyTagMutationVariables = { projectId: string; data: TaxonomyAlias };

/**
 * @summary Upsert Alias
 */
export const useUpsertTaxonomyTag = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof upsertTaxonomyTag>>,
    TError,
    UpsertTaxonomyTagMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof upsertTaxonomyTag>>,
  TError,
  UpsertTaxonomyTagMutationVariables,
  TContext
> => {
  return useMutation(getUpsertTaxonomyTagMutationOptions(options));
};
export const getDeleteTaxonomyAliasUrl = (projectId: string, kind: string, value: string) => {
  return `/api/v1/taxonomy/${projectId}/alias/${kind}/${value}`;
};

/**
 * @summary Delete Alias
 */
export const deleteTaxonomyAlias = async (
  projectId: string,
  kind: string,
  value: string,
  options?: Parameters<typeof customFetch>[1],
): Promise<unknown> => {
  return customFetch<unknown>(getDeleteTaxonomyAliasUrl(projectId, kind, value), {
    ...options,
    method: 'DELETE',
  });
};

export const getDeleteTaxonomyAliasMutationOptions = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteTaxonomyAlias>>,
    TError,
    DeleteTaxonomyAliasMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteTaxonomyAlias>>,
  TError,
  DeleteTaxonomyAliasMutationVariables,
  TContext
> => {
  const mutationKey = ['deleteTaxonomyAlias'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteTaxonomyAlias>>,
    DeleteTaxonomyAliasMutationVariables
  > = (props) => {
    const { projectId, kind, value } = props ?? {};

    return deleteTaxonomyAlias(projectId, kind, value, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteTaxonomyAliasMutationResult = NonNullable<Awaited<ReturnType<typeof deleteTaxonomyAlias>>>;

export type DeleteTaxonomyAliasMutationError = HTTPValidationError;
export type DeleteTaxonomyAliasMutationVariables = { projectId: string; kind: string; value: string };

/**
 * @summary Delete Alias
 */
export const useDeleteTaxonomyAlias = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteTaxonomyAlias>>,
    TError,
    DeleteTaxonomyAliasMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteTaxonomyAlias>>,
  TError,
  DeleteTaxonomyAliasMutationVariables,
  TContext
> => {
  return useMutation(getDeleteTaxonomyAliasMutationOptions(options));
};
export const getListTaxonomyAliasesUrl = (projectId: string) => {
  return `/api/v1/taxonomy/${projectId}/aliases`;
};

/**
 * @summary List Aliases
 */
export const listTaxonomyAliases = async (
  projectId: string,
  options?: Parameters<typeof customFetch>[1],
): Promise<ListTaxonomyAliases200> => {
  return customFetch<ListTaxonomyAliases200>(getListTaxonomyAliasesUrl(projectId), {
    ...options,
    method: 'GET',
  });
};

export const getListTaxonomyAliasesQueryKey = (projectId: string) => {
  return [`/api/v1/taxonomy/${projectId}/aliases`] as const;
};

export const getListTaxonomyAliasesQueryOptions = <
  TData = Awaited<ReturnType<typeof listTaxonomyAliases>>,
  TError = HTTPValidationError,
>(
  projectId: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof listTaxonomyAliases>>, TError, TData>;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListTaxonomyAliasesQueryKey(projectId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listTaxonomyAliases>>> = ({ signal }) =>
    listTaxonomyAliases(projectId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: projectId !== null && projectId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof listTaxonomyAliases>>, TError, TData> & { queryKey: QueryKey };
};

export type ListTaxonomyAliasesQueryResult = NonNullable<Awaited<ReturnType<typeof listTaxonomyAliases>>>;
export type ListTaxonomyAliasesQueryError = HTTPValidationError;

/**
 * @summary List Aliases
 */

export function useListTaxonomyAliases<
  TData = Awaited<ReturnType<typeof listTaxonomyAliases>>,
  TError = HTTPValidationError,
>(
  projectId: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof listTaxonomyAliases>>, TError, TData>;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListTaxonomyAliasesQueryOptions(projectId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}
